import React from "react";
import WomensHealthPage from "../Components/WomensHealth/WomensHealthPage";

const WomensHealth = () => {
  return <WomensHealthPage />;
};

export default WomensHealth;